import { getThemedData } from '$utils'

import carro from './carro'
import motto from './motto'

export const Logo = getThemedData({
  motto,
  carro
})
